import React from 'react';
import { P } from '@fashionnovateam/nova-ui-toolkit';

type StepsProps = {
  stepNumber: number;
  stepText: string | React.ReactNode;
  isLast: boolean;
};

function Steps({ stepNumber, stepText, isLast }: StepsProps) {
  return (
    <div className="twp nu-flex nu-flex-row nu-gap-3 nu-max-w-[620px]">
      <div className="nu-flex nu-flex-col nu-items-center">
        <div className="twp w-[28px] h-[28px] nu-relative nu-rounded-full #FFFFFF nu-flex nu-items-center nu-justify-center nu-border nu-border-neutral-300">
          <div className="nu-text-disabled nu-text-xs">{stepNumber}</div>
        </div>
        {!isLast && (
          <div className="nu-grow border-l h-[12px] nu-border-neutral-300" />
        )}
      </div>
      <div className="nu-flex nu-flex-col nu-gap-2 nu-grow nu-mb-3 nu-min-h-6">
        <P color="secondary" size="md">
          {stepText}
        </P>
      </div>
    </div>
  );
}

export default Steps;
